import { observable } from "mobx";
import ReportStatus from "./reportStatus";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class LustrationReportRequestCreateResponse {
  @observable
  status!: ReportStatus;

  @observable
  existingReportId?: string;
}
